var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.noLabelSetting) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.label')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.optionModel.label),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "label", $$v)
      },
      expression: "optionModel.label"
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ccfe00","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/label-editor.vue
// module id = null
// module chunks = 